//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    backgroundGradient: {
      type: String,
      default: 'linear-gradient(90deg, #3F7AF8 0%, #8A53F7 100%)',
    },
  },
};
